import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { cn } from '../utils/cn';
/**
 * Container fuer die Sidebar-Navigation (`.sec-nav`). Wird typischerweise in
 * den `sidebar`-Slot von `<AppShell>` gelegt (der bereits ein `<nav>` rendert).
 */
export function SidebarNav({ className, children, ...rest }) {
    return (_jsx("div", { className: cn('sec-nav', className), ...rest, children: children }));
}
/** Gruppe von Navigationseintraegen mit optionaler Beschriftung. */
export function NavGroup({ label, className, children, ...rest }) {
    return (_jsxs("div", { className: cn('sec-nav__group', className), ...rest, children: [label ? _jsx("p", { className: "sec-nav__label", children: label }) : null, children] }));
}
/**
 * Einzelner Navigationseintrag (`.sec-nav__item`, 28 px, 13 px/500). Polymorph:
 * `as={NavLink}` reicht Router-Props (`to`, `end`) durch; `active` setzt die
 * `--active`-Modifier-Klasse und `aria-current="page"`.
 */
export function NavItem({ as, active = false, icon, badge, className, children, ...rest }) {
    const Component = as ?? 'a';
    const base = cn('sec-nav__item', active && 'sec-nav__item--active');
    const cls = typeof className === 'function'
        ? (state) => cn(base, className(state))
        : cn(base, className);
    return (_jsxs(Component, { className: cls, "aria-current": active ? 'page' : undefined, ...rest, children: [icon ? _jsx("span", { className: "sec-nav__item-icon", "aria-hidden": "true", children: icon }) : null, _jsx("span", { className: "sec-nav__item-label", children: children }), badge !== undefined && badge !== null ? _jsx("span", { className: "sec-nav__badge", children: badge }) : null] }));
}
